export const msalConfig = {
    auth: {
        clientId: "6b83cdad-4022-44f2-9f8e-038844af1f20",
        authority: "https://login.microsoftonline.com/common",
        redirectUri: window.location.origin + "/index.html",
    },
    cache: {
        cacheLocation: "localStorage", // Changed from sessionStorage to localStorage for persistent login
        storeAuthStateInCookie: true
    }
};

export const loginRequest = {
    scopes: ["User.Read"]
};

// Additional scopes for SharePoint/OneDrive access
export const graphScopes = {
    sharePoint: [
        "User.Read",
        "Sites.Read.All",           // Read SharePoint sites
        "Files.Read.All"            // Read files in OneDrive/SharePoint
    ]
};